import { cn } from 'noddi-ui-common';

interface Props {
  colorHex?: string;
  className?: string;
}

export const TagsCircle = ({ colorHex, className }: Props) => {
  return (
    <div
      className={cn('size-3 rounded-full', !colorHex && 'border border-black bg-white', className)}
      style={{ backgroundColor: colorHex }}
    />
  );
};
